import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { Subject, Subscription, timer } from 'rxjs';
import { ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounce, filter } from 'rxjs/operators';
import { DropdownService } from './dropdown.service';
import { TestHooks } from './top-nav-bar-button.hooks';

@UntilDestroy()
@Component({
	selector: 'app-top-nav-bar-button',
	templateUrl: './top-nav-bar-button.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TopNavBarButtonComponent implements OnInit, OnDestroy {
	testHooks = TestHooks;
	private eventStream = new Subject<boolean>();
	private dropdownSubscription: Subscription;
	public ICON = ICON;

	@Input() id: string;
	@Input() testHook: string;
	@Input() intercomTarget: string;
	@Input() title: string;
	@Input() num: number;
	@Input() icon: string;
	@Input() showPercentage = false;
	@Input() set show(_show: boolean) {
		this.showDropdown = _show;
	}
	@Output() showing: EventEmitter<boolean> = new EventEmitter();

	public showDropdown = false;
	private isMouseInComponent = false;
	private isMouseInDropdown = false;

	constructor(private dropdownService: DropdownService) {
		this.eventStream
			.pipe(
				untilDestroyed(this),
				debounce((shouldShow) => (shouldShow ? timer(0) : timer(500))),
			)
			.subscribe((x) => {
				if (!x && (this.isMouseInComponent || this.isMouseInDropdown)) {
					return;
				}

				this.showing.emit(x);
				this.showDropdown = x;

				if (x && this.id) {
					this.dropdownService.setActiveDropdown(this.id);
				} else if (!x && this.id) {
					this.dropdownService.clearActiveDropdown();
				}
			});
	}

	ngOnInit(): void {
		this.dropdownSubscription = this.dropdownService.activeDropdown$
			.pipe(
				untilDestroyed(this),
				filter((activeId) => activeId !== null && activeId !== this.id),
			)
			.subscribe(() => {
				this.showing.emit(false);
				this.showDropdown = false;
			});
	}

	ngOnDestroy(): void {
		if (this.dropdownSubscription) {
			this.dropdownSubscription.unsubscribe();
		}
	}

	mouseoverButton() {
		this.isMouseInComponent = true;
		this.eventStream.next(true);
	}

	mouseoutButton() {
		this.isMouseInComponent = false;
		if (!this.isMouseInDropdown) {
			this.eventStream.next(false);
		}
	}

	mouseoverDropdown() {
		this.isMouseInDropdown = true;
		this.eventStream.next(true);
	}

	mouseoutDropdown() {
		this.isMouseInDropdown = false;
		if (!this.isMouseInComponent) {
			this.eventStream.next(false);
		}
	}
}
